import { render } from "./ChatbotInput.vue?vue&type=template&id=3423d418&scoped=true&ts=true"
import script from "./ChatbotInput.vue?vue&type=script&lang=ts"
export * from "./ChatbotInput.vue?vue&type=script&lang=ts"

import "./ChatbotInput.vue?vue&type=style&index=0&id=3423d418&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3423d418"]])

export default __exports__